<template>
  <div class="home">
    <div class="query">
      <el-form ref="form" class="search-form" :model="queryForm" label-width="auto" :inline="true" label-position="left">
        <el-form-item label="数据查询范围：" prop="organizationId">
          <el-select v-model="queryForm.organizationId" placeholder="请选择" style="width: 240px" @change="organizationIdChange">
            <el-option v-for="item in selectList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="城市：" style="width: 240px;" :label-width="60">
          <el-select clearable v-model="queryForm.City" placeholder="请选择" style="width: 100%;" @change="cityChange">
            <el-option v-for="item in CityList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="区域："  style="width: 240px;" :label-width="60" clearable>
          <el-select clearable v-model="queryForm.Area" placeholder="请选择" style="width: 100%">
            <el-option v-for="item in AreaList" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间：" style="width: 260px;" :label-width="100">
            <el-date-picker
              value-format="YYYY-MM-DD"
              clearable           
              v-model="queryForm.StartDate"
              type="date"
              placeholder="请选择"
            />
        </el-form-item>
          <el-form-item label="结束时间：" style="width: 260px;" :label-width="100">
            <el-date-picker
            value-format="YYYY-MM-DD"
            clearable
            v-model="queryForm.EndDate"
            type="date"
            placeholder="请选择"
          />
        </el-form-item>
        <el-form-item label="">
          <MyButton icon="Search" @click="initData">查询</MyButton>
          <!-- <MyButton icon="Refresh">重置</MyButton> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="home-title">
      <div class="title-item" v-for="item in totalItem" :key="item.text" >
        <div class="left">
          <img :src="item.img" alt="" />
        </div>
        <div class="right">
          <div>
            <span class="person">{{ item.count }}</span>
            <span>{{ item.text2 }}</span>
          </div>
          <div class="count">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <div class="home-content">
      <div class="content-left" :class="{content100:tabPosition==2}">
        <div class="left-title">
          <div class="left-options" >
              <div class="vertical"></div>
              <div style="margin-right: 20px;">
               <div class="tap-group">
                  <div class="group1" @click="radioChange(1)" :class="{group:tabPosition==2}">综合数据</div>
                  <div class="group2" @click="radioChange(2)" :class="{group:tabPosition==1}">心理状态</div>
               </div>
              </div>
              <!-- <div v-if="tabPosition==2">
                <el-select class='custom-select' @change='radioChange(2)' v-model="queryForm.Name" placeholder="请选择" style="width: 200px;">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </div> -->
          </div>
          <div class="legend" v-if="tabPosition==1">
            <span class="legend1">正常</span>
            <span class="legend2">询问</span>
            <span class="legend3">关注</span>
          </div>
          <div class="legend-two" v-if="tabPosition==2">
            <span class="legend1">正常</span>
            <span class="legend2">轻微</span>
            <span class="legend3">中等</span>
            <span class="legend4">偏重</span>
            <span class="legend5">严重</span>
          </div>
        </div>
        <div class="echarts1" v-if="tabPosition==1">
          <Chart1 :data="data1" />
        </div>
        <div v-if="tabPosition==2">
            <div style="display: flex;height: 50%;">
                <Chart3 :data="data3" />
                <Chart3 :data="data4" />
                <Chart3 :data="data5" />
                <Chart3 :data="data6" />
                <Chart3 :data="data7" />
            </div>
            <div style="display: flex;height: 50%;">
              <Chart3 :data="data8" />
              <Chart3 :data="data9" />
              <Chart3 :data="data10" />
              <Chart3 :data="data11" />
              <Chart3 :data="data12" />  
            </div>  
        </div>
      </div>
      <div class="content-right" v-if="tabPosition==1">
        <div class="content-title">数据解析</div>
        <div class="sub-title">
          {{ `AI测评分析人数为 ${data2.totalEvaluationNum}人，有效采集数据 ${data2.effectivityEvaluationNum}人，需要重点关注的人员 ${data2.concernPeopleNum}人，占比 
          ${data2.concernPercentum}%，其中轻度人数为 ${data2.mildPeopleNum}人，占比 ${data2.mildPercentum}%，正常数 ${data2.normalPeopleNum}人，占比 ${data2.normalPercentum}%。` }}
        </div>
        <div class="echarts2">
          <Chart2 :data="data2" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref ,onMounted, onUnmounted} from "vue";
import { local } from "@/utils/storage.js";
import main1 from "@/assets/svgs/main1.svg";
import main2 from "@/assets/svgs/main2.svg";
import main3 from "@/assets/svgs/main3.svg";
import main4 from "@/assets/svgs/main4.svg";
import main5 from "@/assets/svgs/main5.svg";
import Chart1 from "./Chart1.vue";
import Chart2 from "./Chart2.vue";
import Chart3 from "./Chart3.vue";
import organizationApi from "@/api/organization";
import {getMentalState,dictdataapp} from "@/api/statisticalPsychological"

const tabPosition=ref(1)

const CityList=ref([])
const AreaList=ref([])
const obj=ref({
  organizationId:"",
  code:"orgAddress",
})
const organizationIdChange=()=>{
      queryForm.City=""
      queryForm.Area=""
      CityList.value=[]
      AreaList.value=[]
      dictdataappData(queryForm.organizationId)
      local.set('isId',queryForm.organizationId)
}
const cityChange=()=>{
       AreaList.value=[]
       queryForm.Area=""
       list.value.forEach(item=>{
          if(item.pId!=0){
            if(queryForm.City==item.pId){
              AreaList.value.push(item)
            }
          }
       })
}
const list=[]
const dictdataappData=(organizationId)=>{
      obj.value.organizationId=organizationId
      dictdataapp(obj.value).then(res=>{
            if(res.data.length>0){
                list.value=res.data
                res.data.forEach(item=>{
                    if(item.pId==0){
                       CityList.value.push(item)
                    }
                })
            }
      })
}


const queryForm = reactive({
  organizationId: "",
  City:"",
  Area:"",
  StartDate:"",
  EndDate:"",
});

const radioChange=(type)=>{
  tabPosition.value=type
  if(tabPosition.value==2){
    getMentalStateData()
  }else{
    getComprehensiveData()
    getIndicatorData()
  }
}
const data3=ref({})
const data4=ref({})
const data5=ref({})
const data6=ref({})
const data7=ref({})
const data8=ref({})
const data9=ref({})
const data10=ref({})
const data11=ref({})
const data12=ref({})
const getMentalStateData=()=>{
     getMentalState(queryForm).then(res=>{
      data3.value=res.data[0]
      data4.value=res.data[1]
      data5.value=res.data[2]
      data6.value=res.data[3]
      data7.value=res.data[4]
      data8.value=res.data[5]
      data9.value=res.data[6]
      data10.value=res.data[7]
      data11.value=res.data[8]
      data12.value=res.data[9]
     })
}
const selectList = ref([]);
const getSelectList = async () => {
  organizationApi.getUnitList({
    SkipCount: 0,
    MaxResultCount: 1000,
  }).then((res) => {
    selectList.value = res.data.items.map((item) => {
      return {
        label: item.name,
        value: item.id,
        ...item
      }
    })
    queryForm.organizationId = selectList.value[0].id
    // 待选中的id，从本地缓存读取
    const targetSelectId =local.get('isId')
    if(targetSelectId){
      queryForm.organizationId=targetSelectId
    }
    initData();
    dictdataappData(selectList.value[0].id)
  })
}


const totalItem = ref([
  {
    img: main1,
    count: 0,
    text2: "人",
    text: "总人数",
  },
  {
    img: main2,
    count: 0,
    text2: "次",
    text: "累计检测次数",
  },
  {
    img: main3,
    count: 0,
    text2: "人",
    text: "昨日新增人数",
  },
  {
    img: main4,
    count: 0,
    text2: "次",
    text: "今日检测人数",
  },
  {
    img: main5,
    count: 0,
    text2: "次",
    text: "今日检测次数",
  },
]);
const data1 = ref([])
const data2 = ref({
  totalEvaluationNum: 0,
  effectivityEvaluationNum: 0,
  mildPeopleNum: 0,
  mildPercentum: 0,
  concernPeopleNum: 0,
  concernPercentum: 0,
  normalPeopleNum: 0,
  normalPercentum: 0
})
const getComprehensiveData=()=>{
     data1.value=[]
    organizationApi.getComprehensive(queryForm).then((res) => {
      data1.value = res.data
    })
}
const getIndicatorData=()=>{
      organizationApi.getIndicator(queryForm).then((res) => {
        data2.value={}
        Object.assign(data2.value, res.data)
      })
}
const initData = () => {
  if(tabPosition.value==1){
    getComprehensiveData()
    organizationApi.getStatistics(queryForm.organizationId).then((res) => {
      totalItem.value[0].count = res.data.totalNum
      totalItem.value[1].count = res.data.evaluationNum
      totalItem.value[2].count = res.data.yesterdayAddNum
      totalItem.value[3].count = res.data.todayEvaluationPeopleNum
      totalItem.value[4].count = res.data.todayEvaluationNum
    })
    getIndicatorData()
  }else{
    getMentalStateData()
  }
}




onMounted(()=>{
  getSelectList();
})
</script>

<style lang="scss" scoped>
.content100{
  width: 100% !important;
}
.group{
  color: #666;
}
.tap-group{
  display: flex;
  align-items: center;
  cursor: pointer;
  .group1{
    text-align: center;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid #02447E;
    border-radius: 10px 0px 0px 0px;
  }
  .group2{
    text-align: center;
    padding: 8px;
    box-sizing: border-box;
    border: 1px solid #02447E;
    border-radius: 0px 10px 0px 0px;
  }
}
.home {
  padding: 10px !important;
  background: none !important;
  .home-title {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .title-item {
      color: #6fcaf7;
      width: 310px;
      height: 140px;
      padding: 0 50px;
      background: url("@/assets/svgs/login_btn.svg#svgView(preserveAspectRatio(none))") no-repeat center center;
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      gap: 20px;
      .left {
        width: 45px;
        img{
          width: 100%;
        }
      }
      .right {
        .person {
          color: #4aefff;
          font-size: 44px;
          margin-right: 14px;
          margin-bottom: 2px;
        }
        .count {
          margin-left: 4px;
        }
      }
    }
  }
  .home-content {
    color: #6fcaf7;
    min-height: 610px;
    display: flex;
    gap: 20px;
    .content-left {
      width: 60%;
      padding: 30px 60px;
      background: url("@/assets/svgs/home_left.svg#svgView(preserveAspectRatio(none))") no-repeat;
      background-size: 100% 100%;
      display: grid;
      grid-template-rows: auto 1fr;
      .left-title{
        display: flex;
        justify-content: space-between;
          .left-options{
            display: flex;
            align-items: center;
            .vertical{
              width: 4px;
              height: 16px;
              background: #4aefff;
              margin-right: 6px;
            }
            .text{
                color: #4aefff;
                font-size: 18px;
                margin-right: 20px;
            }
          }
      }
      .legend{
        display: flex;
        align-items: center;
        gap: 20px;
        >span {
          display: flex;
          align-items: center;
          gap: 5px;
          &::before{
            display: block;
            content: "";
            width: 14px;
            height: 14px;
            border-radius: 50%;
          }
          &:nth-child(1){
            color: #27A4FD;
            &::before{
              background: linear-gradient(180deg, #AED4F0 0%, #23A2FD 100%);
            }
          }
          &:nth-child(2){
            color: #FDC631;
            &::before{
              background: linear-gradient(180deg, #FF9400 0%, #FFCF8E 100%);
            }
          }
          &:nth-child(3){
            color: #FF7A68;
            &::before{
              background: linear-gradient(180deg, #FF573C 0%, #FFB2AF 100%);
            }
          }
        }
      }
      .legend-two{
        display: flex;
        align-items: center;
        gap: 20px;
        >span {
          display: flex;
          align-items: center;
          gap: 5px;
          &::before{
            display: block;
            content: "";
            width: 14px;
            height: 14px;
            border-radius: 50%;
          }
          &:nth-child(1){
            color: #409EFF;
            &::before{
              background: #409EFF;
            }
          }
          &:nth-child(2){
            color: #67C23A;
            &::before{
              background: #67C23A;
            }
          }
          &:nth-child(3){
            color: #FFEB3B;
            &::before{
              background: #FFEB3B;
            }
          }
           &:nth-child(4){
            color: #FF9800;
            &::before{
              background: #FF9800;
            }
          }
          &:nth-child(5){
            color: #F56C6C;
            &::before{
              background: #F56C6C;
            }
          }
        }
      }
    }
    .content-right {
      width: 40%;
      background: url("@/assets/svgs/home_right.png#svgView(preserveAspectRatio(none))") no-repeat;
      background-size: 100% 100%;
      padding: 30px 60px;
      display: grid;
      grid-template-rows: auto auto 1fr;
      .sub-title {
        display: flex;
        &::before {
          display: block;
          content: "";
          width: 8px;
          height: 8px;
          margin-right: 10px;
          margin-top: 5px;
          border-radius: 50%;
          background: #4aefff;
          flex-shrink: 0;
        }
      }
    }
  }
}
:deep() {
  .el-progress-bar__outer {
    background: #0c4f71;
  }  
}
// .content-left {
// // 🔥 终极生效版 Element Plus
// :deep(.custom-select) .el-select__wrapper {
//   background-color: #124e91 !important;
//   border: 1px solid #02447E !important;
//   box-shadow: none !important;
// }
// :deep(.custom-select) .el-select__placeholder {
//   color: #6fcaf7 !important;
//   background: transparent !important;
// }
// :deep(.custom-select) .el-input__placeholder {
//   color: #6fcaf7 !important;
// }
// :deep(.custom-select) .el-select__caret {
//   color: #6fcaf7 !important;
// }
// }

</style>
